import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '../../../contexts/PermissionsContext';

export default function Area({ areas, handleOpenModal, pagination }) {
  const { t } = useTranslation('MasterData');
  const [startIndex, setStartIndex] = useState(0);
  useEffect(() => {
    setStartIndex(pagination.per_page * (pagination.current_page - 1) + 1);
  }, [pagination]);
  const { permissions } = usePermissions();
  console.log('area >>>>>>>>>>', areas);
  const areaDatas = Array.isArray(areas) ? areas : [];
  return (
    <div className="table-outer">
      <table className="table">
        <thead>
          <tr className="t-heading">
            <th className="id">
              <h5>#</h5>
            </th>
            <th className="name">
              <h5>{t('AREA')}</h5>
            </th>
            <th className="action">
              {permissions?.MASTER_DATA_AREA?.edit_permission === 1 && (
                <h5>{t('ACTION')}</h5>
              )}
            </th>
          </tr>
        </thead>
        <tbody>
          {areaDatas.length === 0 ? (
            <tr>
              <td colSpan="100%" className="text-center py-4">
                {t('NORECODAVAILABLE')}
              </td>
            </tr>
          ) : (
            areaDatas?.map((area, index) => (
              <tr key={index}>
                <td className="id">
                  <h5>{index + startIndex}</h5>
                </td>
                <td className="name">
                  <h5>{area?.name}</h5>
                </td>
                <td className="action">
                  {permissions?.MASTER_DATA_AREA?.edit_permission === 1 && (
                    <>
                      <div div className="d-flex">
                        <button
                          className="edit"
                          // data-bs-toggle="modal"
                          // data-bs-target="#edit-customer-area"
                          onClick={() => handleOpenModal('edit', area)}
                        >
                          <img src="images/green-edit.svg" alt="Edit" />
                        </button>
                        <button
                          className="delete"
                          onClick={() => handleOpenModal('delete', area)}
                        >
                          <img src="images/red-delete.svg" alt="" />
                        </button>
                      </div>
                    </>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
